import { render, staticRenderFns } from "./WelcomeVendor.vue?vue&type=template&id=1c80e6b4&"
import script from "./WelcomeVendor.vue?vue&type=script&lang=js&"
export * from "./WelcomeVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports